import Api from '@/services/api';
import qs from 'querystring';

export default {
  send(phone, text) {
    return Api().post('/sms/send', qs.stringify({
      phone: phone,
      text: text,
    }));
  },
}